module.exports = __webpack_public_path__ + "static/img/systen-set.82381d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/systen-set.png
// module id = ARwA
// module chunks = 58